/* Short editorial motion and user-controlled chapters. All shopping remains native. */
(() => {
  'use strict';
  if (window.__coinyEditorialV8) return;
  window.__coinyEditorialV8 = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const restrained = () => reduced.matches || Boolean(navigator.connection?.saveData);
  const running = new Set();
  const stories = new WeakSet();
  const seen = new WeakSet();
  const controllers = new Set();

  function animate(element, keyframes, duration) {
    if (restrained() || !element?.animate || document.hidden) return;
    const animation = element.animate(keyframes, {duration, easing:'cubic-bezier(.2,.65,.25,1)'});
    running.add(animation);
    const done = () => running.delete(animation);
    animation.onfinish = done;
    animation.oncancel = done;
    return animation;
  }
  function stopMotion() {
    running.forEach(animation => animation.cancel());
    running.clear();
  }
  function syncMotionPreference() {
    const paused = restrained() || document.hidden;
    document.documentElement.setAttribute('data-cm-v8-motion', paused ? 'paused' : 'ready');
    if (paused) stopMotion();
  }
  reduced.addEventListener?.('change', syncMotionPreference);
  navigator.connection?.addEventListener?.('change', syncMotionPreference);
  document.addEventListener('visibilitychange', syncMotionPreference);
  syncMotionPreference();

  function initializeStory(root) {
    if (stories.has(root)) return;
    const buttons = [...root.querySelectorAll('[data-cm-chapter]')];
    const panels = [...root.querySelectorAll('[data-cm-chapter-panel]')];
    if (buttons.length !== 2 || panels.length !== 2) return;
    stories.add(root);
    let current = -1;
    let transition;
    function select(index, moveFocus = false) {
      if (index < 0 || index >= panels.length) return;
      if (current === index) { if (moveFocus) buttons[index].focus(); return; }
      transition?.cancel();
      buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === index));
        button.tabIndex = i === index ? 0 : -1;
      });
      panels.forEach((panel, i) => { panel.hidden = i !== index; });
      if (current !== -1) transition = animate(panels[index], [{opacity:.5,transform:'translateY(7px)'},{opacity:1,transform:'translateY(0)'}], 420);
      root.dataset.cmChapter = String(index + 1);
      current = index;
      if (moveFocus) buttons[index].focus();
    }
    buttons.forEach((button, index) => {
      button.addEventListener('click', () => select(index));
      button.addEventListener('keydown', event => {
        let next;
        if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
        else if (event.key === 'ArrowLeft') next = (index + buttons.length - 1) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault();
        select(next, true);
      });
    });
    root.classList.add('cm-v8-chapters-ready');
    select(location.hash === '#money-in-motion' ? 1 : 0);
    controllers.add({root, select});
  }

  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      animate(entry.target, [{opacity:.65,transform:'translateY(15px)'},{opacity:1,transform:'translateY(0)'}], 620);
    });
  }, {threshold:.12}) : null;

  function init(root) {
    root.querySelectorAll('[data-cm-chapters]').forEach(initializeStory);
    root.querySelectorAll('.cm-v8-hero-frame img').forEach(hero => {
      if (seen.has(hero)) return;
      seen.add(hero);
      const entrance = () => animate(hero, [{transform:'scale(1.028)'},{transform:'scale(1)'}], 950);
      if (hero.complete) entrance();
      else hero.addEventListener('load', entrance, {once:true});
    });
    root.querySelectorAll('[data-cm-editorial-reveal]').forEach(element => {
      if (seen.has(element)) return;
      seen.add(element);
      if (element.getBoundingClientRect().top > innerHeight) observer?.observe(element);
    });
  }
  function revealDestination(hash) {
    if (hash === '#choose-your-set' || hash === '#build-a-kit') {
      document.querySelectorAll('[data-cm-bundle-disclosure]').forEach(details => { details.open = true; });
    }
    if (hash === '#money-in-motion') {
      controllers.forEach(controller => {
        if (controller.root.isConnected) controller.select(1);
        else controllers.delete(controller);
      });
    }
  }
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href]');
    if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const destination = new URL(link.href, location.href);
    if (destination.origin === location.origin && destination.pathname === location.pathname) revealDestination(destination.hash);
  });
  window.addEventListener('hashchange', () => revealDestination(location.hash));
  document.addEventListener('shopify:section:load', event => { init(event.target); revealDestination(location.hash); });
  document.addEventListener('shopify:section:unload', () => { controllers.forEach(controller => { if (!controller.root.isConnected) controllers.delete(controller); }); });
  init(document);
  revealDestination(location.hash);
})();
